import React from 'react'
import { Typography, Stack } from '@stvgroup/stv-ui-components'
import { ScanSearch } from 'lucide-react'

const NoResults = () => (
  <Stack sx={{
    textAlign: 'center', mt: 4, justifyContent: 'center', alignItems: 'center',
  }}
  >
    <ScanSearch size={44} strokeWidth={1.25} />
    <Typography
      variant="h4"
      sx={{
        mt: 1.5, mb: 1, fontSize: '20px', fontWeight: 600,
      }}
    >We couldn’t find any results
    </Typography>
    <Typography variant="body1" sx={{ color: '#C4C4C4' }}>
      Try checking your spelling, or looking for another show.
    </Typography>
  </Stack>
)

export default NoResults
